namespace TabAurous.Production {
    export namespace JobWorkDismantlingReturnItemsService {
        export const baseUrl = 'Production/JobWorkDismantlingReturnItems';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<DismantlingReturnItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/JobWorkDismantlingReturnItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>JobWorkDismantlingReturnItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
